import Authentication from './Authentication';

/**
 * Higher Order Component that redirect to login page when current user is not logged in
 * @param {Function} WrappedComponent - Route Component
 * @returns {Function} React Component
 */
function withAuthentication(WrappedComponent) {
  function WithAuthentication(props) {
    return (
      <Authentication>
        <WrappedComponent {...props} />
      </Authentication>
    );
  }

  const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

  WithAuthentication.displayName = `withAuthentication(${wrappedComponentName})`;

  return WithAuthentication;
}

export default withAuthentication;
